var map = {
	"./cs.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/cs.json",
		"SkipToContent-i18n-cs-json"
	],
	"./da.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/da.json",
		"SkipToContent-i18n-da-json"
	],
	"./de.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/de.json",
		"SkipToContent-i18n-de-json"
	],
	"./en.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/en.json"
	],
	"./es.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/es.json",
		"SkipToContent-i18n-es-json"
	],
	"./fi.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/fi.json",
		"SkipToContent-i18n-fi-json"
	],
	"./fr.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/fr.json",
		"SkipToContent-i18n-fr-json"
	],
	"./hi.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/hi.json",
		"SkipToContent-i18n-hi-json"
	],
	"./it.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/it.json",
		"SkipToContent-i18n-it-json"
	],
	"./ja.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/ja.json",
		"SkipToContent-i18n-ja-json"
	],
	"./ko.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/ko.json",
		"SkipToContent-i18n-ko-json"
	],
	"./ms.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/ms.json",
		"SkipToContent-i18n-ms-json"
	],
	"./nb.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/nb.json",
		"SkipToContent-i18n-nb-json"
	],
	"./nl.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/nl.json",
		"SkipToContent-i18n-nl-json"
	],
	"./pl.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/pl.json",
		"SkipToContent-i18n-pl-json"
	],
	"./pt-BR.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/pt-BR.json",
		"SkipToContent-i18n-pt-BR-json"
	],
	"./pt-PT.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/pt-PT.json",
		"SkipToContent-i18n-pt-PT-json"
	],
	"./sv.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/sv.json",
		"SkipToContent-i18n-sv-json"
	],
	"./th.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/th.json",
		"SkipToContent-i18n-th-json"
	],
	"./tr.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/tr.json",
		"SkipToContent-i18n-tr-json"
	],
	"./zh-CN.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/zh-CN.json",
		"SkipToContent-i18n-zh-CN-json"
	],
	"./zh-TW.json": [
		"./app/assets/javascripts/components/polaris/react/skip-to-content/locales/zh-TW.json",
		"SkipToContent-i18n-zh-TW-json"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./app/assets/javascripts/components/polaris/react/skip-to-content/locales lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;